import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomerService } from '../shared/services/customer/customer.service';
import { TooltipModule } from '../shared/templates/tooltip/tooltip.module';
import { CustomerComponent } from './customer.component';
import { SampleBillModal } from './sampleBillModal.component';
import { SharedModule } from '../shared/shared.module';
import { LocaleModule } from '../shared/templates/Locale/locale.module';
import { OptSharedModule } from '../shared/opt-shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
        SharedModule,
        LocaleModule,
        OptSharedModule,
        MatIconModule,
        MatProgressSpinnerModule,
        CustomerComponent,
        SampleBillModal,
    ],
    providers: [
        CustomerService
    ]
})
export class CustomerModule { }
